export default {
  data()
  {
    return {}
  },
  methods: {
    updateAlternate()
    {
      // detect lang
      let lang = 'en' // by default
      switch (localStorage.getItem('lang'))
      {
        case 'ee':
        {
          lang = 'et'
        }
      }
      document.documentElement.lang = lang
      const routes = this.$router.getRoutes()
      // Remove link alternate tags to the document head.
      Array.from(document.querySelectorAll('[data-router-alternate-tag]')).map(el => el.parentNode.removeChild(el))
      // console.log(location.pathname)
      // console.log(routes)
      let originRoute = null
      if (lang === 'en') {
        let searchPath = location.pathname.replace(/\/en\//g, '/')
        if (searchPath === '/') { searchPath = '' }
        // const searchPath = location.pathname.replace(/\//g, '')
        // console.log('Search by:', searchPath)
        originRoute = routes.filter(r => r.path === searchPath)
      }
      if (lang === 'et') {
        const searchMeta = location.pathname.replace(/\/et\//g, '/').replace(/\//g, '')
        let searchPath = ''
        if (location.pathname === '/') { searchPath = '/et' } else { searchPath = '/et/' + searchMeta }
        originRoute = routes.filter(r => (r.meta.en === searchMeta || r.path === searchPath))
      }

      if (originRoute && originRoute[0] && originRoute[0].meta)
      {
        const to = originRoute[0]
        this.updateMetaTags(to)
        console.log('Applied meta from this route:', to)
        const alternateTags = []
        const originPath = window.location.origin
        if (to.path.includes('/et/') || to.path === '/et')
        {
          let href = originPath + to.path.replace(/\/et\//g, '/en/')
          if (to.meta.en)
          {
            if (to.params && to.params.id)
            {
              to.meta.en = to.meta.en.replace(/:id/g, to.params.id)
            }
            href = originPath + '/en/' + to.meta.en
          } else if (to.path === '/' || to.path === '/et') {
            href = originPath + '/en/'
          }
          alternateTags.push(
            {
              rel: 'alternate',
              hreflang: 'en',
              href: href
            }
          )
        }
        else
        {
          let href = originPath + '/et' + to.path.replace(/\/en\//g, '')
          if (to.params && to.params.id)
          {
            to.meta.et = to.meta.et.replace(/:id/g, to.params.id)
          }
          if (to.meta.et)
          {
            href = originPath + '/et/' + to.meta.et
          }
          alternateTags.push(
            {
              rel: 'alternate',
              hreflang: 'et',
              href: href
            }
          )
        }
        // console.log('Set alternateTags:', alternateTags)
        alternateTags.map(tagDef =>
        {
          const tag = document.createElement('link')

          Object.keys(tagDef).forEach(key =>
          {
            tag.setAttribute(key, tagDef[key])
          })

          // We use this to track which meta tags we create, so we don't interfere with other ones.
          tag.setAttribute('data-router-alternate-tag', '')

          return tag
        })
          // Add the link alternate tags to the document head.
          .forEach(tag => document.head.appendChild(tag))
      }
    },
    updateMetaTags(to)
    {
      // Remove any stale meta tags from the document using the key attribute we set below.
      Array.from(document.querySelectorAll('[data-router-meta-tag]')).map(el => el.parentNode.removeChild(el))
      // Skip rendering meta tags if there are none.
      if (!to.meta)
      {
        return false
      }
      const results = []
      if (to.meta.title)
      {
        const title = to.meta.title + ' | ' + process.env.VUE_APP_TITLE
        document.title = title
        results.push({name: 'title', content: title})
        results.push({property: 'og:title', content: title})
        results.push({property: 'twitter:title', content: title})
      }
      if (to.meta.description)
      {
        results.push({
          name: 'description',
          content: to.meta.description,
          id: 'desc'
        })
        results.push({property: 'og:description', content: to.meta.description})
        results.push({property: 'twitter:description', content: to.meta.description})
      }
      results.push({property: 'og:type', content: 'website'})
      results.push({property: 'og:url', content: location.protocol + '//' + location.host + to.path})
      results.push({property: 'og:image', content: location.protocol + '//' + location.host + '/img/income-fb.jpg'})
      results.push({property: 'twitter:image', content: location.protocol + '//' + location.host + '/img/income-fb.jpg'})
      results.push({property: 'og:image:alt', content: 'Income Marketplace logo'})
      results.push({property: 'twitter:card', content: 'summary'})

      // Turn the meta tag definitions into actual elements in the head.
      results.map(tagDef =>
      {
        const tag = document.createElement('meta')

        Object.keys(tagDef).forEach(key =>
        {
          tag.setAttribute(key, tagDef[key])
        })

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute('data-router-meta-tag', '')

        return tag
      })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag))
      return true
    }
  }
}
